module.exports = "<p class=\"h-http-error\">\r\n    <span class=\"h-http-error__accent\">Uh oh, there was a problem loading your data.</span class=\"h-http-error__accent\"><br />\r\n    If the problem persists, please contact us to resolve the error.\r\n</p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/angular/http-error/http-error.html
// module id = 352
// module chunks = 0